export default __webpack_public_path__ + "static/media/Sovereign of Anarchy.7c3876c3.jpg";